export default "__VITE_ASSET__LrOyf4YO__"